"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Proofreading = void 0;
const react_1 = __importStar(require("react"));
const fromFetchSSEStream_1 = require("copilot-js/dist/helpers/fromFetchSSEStream");
const util_1 = require("./util");
const api_1 = require("./api");
const CopilotSetting_1 = require("./CopilotSetting");
const reportTokenUsage_1 = require("@/utils/reportTokenUsage");
const Proofreading = ({ text, translation, langId, context, prompt, projectId, }) => {
    const [evaluation, setEvaluation] = react_1.default.useState();
    (0, react_1.useEffect)(() => {
        const controller = new AbortController();
        const callback = (fragment) => {
            setEvaluation((prev) => {
                return (prev || "") + fragment;
            });
        };
        const filter = (0, util_1.createFilter)(callback, false);
        const responsePromise = (() => __awaiter(void 0, void 0, void 0, function* () {
            // const context = await contextPromise;
            const model = (0, CopilotSetting_1.getCopilotSetting)().proofreadingModel;
            return (0, api_1.chatCompletionWithContext)({
                model,
                context,
                controller,
                prompt: Object.assign(Object.assign({}, api_1.defaultProofReadingPrompt), prompt),
                params: {
                    langId,
                    text,
                    translation,
                },
            });
        }))();
        (0, fromFetchSSEStream_1.fromFetchSSEStream)({
            callback: (data) => {
                // ストリームが完了した時点でトークン使用量を報告
                if (data.usage) {
                    const model = (0, CopilotSetting_1.getCopilotSetting)().proofreadingModel;
                    (0, reportTokenUsage_1.reportTokenUsage)(model !== null && model !== void 0 ? model : "unknown", data.usage.prompt_tokens, data.usage.completion_tokens, projectId).catch(console.error);
                }
                if (data.choices.length === 0)
                    return;
                filter(data.choices[0].delta.content || "");
            },
            controller,
            responsePromise,
        });
    }, [text, translation, langId]);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("span", null, "\u5143\u306E\u30C6\u30AD\u30B9\u30C8"),
        react_1.default.createElement("div", { style: {
                maxWidth: "640px",
                whiteSpace: "pre-wrap",
                border: "1px solid #999",
                padding: "10px",
                borderRadius: "5px",
                margin: "10px",
                minHeight: "80px",
            } }, text),
        react_1.default.createElement("span", null, "\u7FFB\u8A33\u6587"),
        react_1.default.createElement("div", { style: {
                maxWidth: "640px",
                whiteSpace: "pre-wrap",
                border: "1px solid #999",
                padding: "10px",
                borderRadius: "5px",
                margin: "10px",
                minHeight: "80px",
            } }, translation),
        react_1.default.createElement("span", null, "\u8A55\u4FA1\u3068\u30B3\u30E1\u30F3\u30C8"),
        react_1.default.createElement("div", { style: {
                maxWidth: "640px",
                whiteSpace: "pre-wrap",
                border: "1px solid #999",
                padding: "10px",
                borderRadius: "5px",
                margin: "10px",
                minHeight: "80px",
            } }, evaluation)));
};
exports.Proofreading = Proofreading;
